import { registration } from 'backend/auth';
import { local } from 'wix-storage';
import wixLocation from 'wix-location';
import wixUsers from 'wix-users';

$w.onReady(function () {

});

export function registration_click(event) {
    let name = $w('#name').value;
    let last = $w('#last').value;
    let email = $w('#email').value;
    let phone = $w('#phone').value;
    let city = $w('#city').value;
    // let password = $w('#password').value;
    // let password2 = $w('#password2').value;
    let terms = $w('#terms').checked;

    // if (password === password2) {
    if (!($w('#error').collapsed)) {
        $w('#error').collapse();
    }

    // 	$w('#registration').collapse();
    $w('#loading').expand();

    // 	let getNews = $w('#newsSwitch').checked;

    // 	if (getNews) {
    // 		wixUsers.register(email, password)
    // 			.then((result) => {
    // 				console.log(result);
    // 			});
    // 	}

    if (terms) {
        // let getNews = $w('#newsSwitch').checked;
        let getNews = 0;

        // if (getNews) {
        //     wixUsers.register(email, 'password')
        //         .then((result) => {
        //             console.log(result);
        //         });
        // }

        registration(name, last, email, phone, city, getNews).then(response => {
                console.log(response);
                if (response.error) {
                    throw new Error(response.error.message);
                }

                let user = JSON.stringify(response);
                local.setItem("fromRegistration", user);
                wixLocation.to('/lp-login');
            })
            .catch(error => {
                console.log(error.message);

                $w('#registration').expand();
                $w('#loading').collapse();

                switch (error.message) {
                case 'EMAIL_EXISTS':
                    $w('#error').text = 'Вече има регистриран потребител със същия имейл!';
                    $w('#error').expand();
                    break;

                case 'WEAK_PASSWORD':
                    $w('#error').text = 'Паролата трябва да е поне 6 символа!';
                    $w('#error').expand();
                    break;

                case 'INVALID_EMAIL':
                    $w('#error').text = 'Невалиден имейл!';
                    $w('#error').expand();
                    break;
                }
            });
    } else {
        $w('#loading').collapse();
        $w('#registration').expand();
        $w('#error').text = 'Трябва да се съгласите с общите условия.';
        $w('#error').expand();
    }

}